import { CommandProps } from '@tiptap/core';
import { TextSelection } from '@tiptap/pm/state';

import { sectionManagerKey, TSectionMeta } from '../SectionNode';

/**
 * Unwrap content from a section at the given position.
 */
const unwrapSectionCommand =
  (pos: number) =>
  ({ state, tr, dispatch }: CommandProps) => {
    const node = state.doc.nodeAt(pos);
    if (node?.type.name !== 'section') return false;

    if (dispatch) {
      // Set delta meta for O(1) section count update
      tr.setMeta(sectionManagerKey, { delta: -1 } as TSectionMeta);
      tr.replaceWith(pos, pos + node.nodeSize, node.content);
      // Place cursor at the start of where the section was
      tr.setSelection(TextSelection.create(tr.doc, pos + 1));
      dispatch(tr);
    }
    return true;
  };

export default unwrapSectionCommand;
